export default "__VITE_ASSET__AjFEY6HC__"